import routerOptions0 from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}